/**
 * A module containing utilities for structuring tests.
 * @module abt-utils/structure
 */

import _ from 'lodash'

/**
 * Get the default exported value from a module.
 * @param {object} module - The module using a default export.
 * @returns {*} The default exported value from a module.
 */
export function getDefault (module) {
  return module.default
}

/**
 * Assumes the default export is a function that can be applied.
 * @param {object} test - The test config to pass in during application.
 * @returns {object|Promise} The test config or a promise that will resolve with the test config.
 */
export function applyDefault (test) {
  return function (module) {
    return getDefault(module)(test)
  }
}

/**
 * Compose individual components of an A/B test structure.
 *
 * Alters the default behaviour of lodash's merge. Object properties and arrays will always be
 * overriden. Priority from low to high: .json config, live config, views
 *
 * @param {object} config - The test config.
 * @param {object} liveConifg - The test live config overrides.
 * @param {object} views - The test large & small view implementations.
 * @returns {object} The composed test.
 */
export function composeTest (config, liveConfig, views) {
  return _.mergeWith({}, config, liveConfig, views, function (a, b) {
    return _.isArray(a) ? b : undefined
  })
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-utils/structure.js
 ** module id = 7
 ** module chunks = 2
 **/